// ScatterDemogsChart.jsx
import  {useState} from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Label
} from "recharts";

// colour palette for groups (match your legend colours)
const GROUP_COLOURS = {
  Age: "#1f77b4",
  Education: "#ff7f0e",
  Gender: "#d62728",
  Migration: "#2ca02c",
  //"Vote 2025": "#c7c7c7",
};
// matcher because named the columns stupidly
function getGroupKeys(polLevel) {
  // first build the normal mapping: shortName -> longKey
  const forward =
    polLevel === "past"
      ? {
          D66: "past_vote_D66",
          CDA: "past_vote_CDA",
          GLpvdA: "past_vote_GLpvdA",
          OtherCentre: "past_vote_OtherCentre",
          OtherLeft: "past_vote_OtherLeft",
          OtherRight: "past_vote_OtherRight",
          PVV: "past_vote_PVV",
          VVD: "past_vote_VVD",
        }
      : (() => {
          const level = polLevel === "LE" ? "LE" : "GE";
          return {
            D66: `D66_${level}_p`,
            PVV: `PVV_${level}_p`,
            VVD: `VVD_${level}_p`,
            GLpvdA: `GLpvdA_${level}_p`,
            CDA: `CDA_${level}_p`,
            OtherRight: `OtherRight_${level}_p`,
            OtherLeft: `OtherLeft_${level}_p`,
            OtherCentre: `OtherCentre_${level}_p`,
          };
        })();

  // invert it: longKey -> shortName
  return Object.fromEntries(Object.entries(forward).map(([shortName, longKey]) => [longKey, shortName]));
}



// helper to map type_code → group (adjust as needed)
function getGroup(type_code) {
  if (["Age"].includes(type_code)) return "Age";
  if (["Education"].includes(type_code)) return "Education";
  if (["Gender"].includes(type_code)) return "Gender";
  if (["Migration"].includes(type_code)) return "Migration";
  if (["Vote 2025"].includes(type_code)) return "Vote 2025";
  return null;
}

export default function ScatterDemogsChart({ scatterDemogsRows, selectedParty,polLevel }) {
  const [hovered, setHovered] = useState(null);
if(!scatterDemogsRows||!selectedParty){return}

const party_name_lookup = getGroupKeys(polLevel);

  // selectedParty is long key like "D66_GE_p"
  const shortParty = party_name_lookup[selectedParty]; // "D66"

console.log("scatterDemogsRows",scatterDemogsRows)

const level = polLevel === "LE" ? "LE" : "GE";


  // build data array for current party
  const data = scatterDemogsRows
    .filter((row) => row.type !== "Vote 2025")
    .filter((row) => (polLevel === "past" ? row.election === "GE" : row.election === level))
    .map((row) => {
      const base = Number(row[`${shortParty}_2025`]) || 0;
      const pred = Number(row[`${shortParty}_vi`]) || 0;

      return {
        x: base * 100,
        y: pred * 100,
        name: row.type_name,
        group: getGroup(row.type),
        changelabel: Math.abs((pred - base) * 100),
        size: Math.abs(pred - base), // tweak scaling in chart if needed
      };
    });
  return  (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center", // centre horizontally
        alignItems: "center",     // centre vertically
        position: "relative",   // ⬅️ important so tooltip can absolutely position
      }}
    >
    <ResponsiveContainer width="100%" height={500}>
      <ScatterChart
        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
  onMouseLeave={() => setHovered(null)}   // ⬅️ clear tooltip when leaving chart
      >
        <CartesianGrid />
        <XAxis
          type="number"
          dataKey="x"
          name="2025 Vote Share"
          unit="%"
                  domain={[
                    (dataMin) => dataMin * 0.9,   // 10% below min
                    (dataMax) => dataMax * 1.1,   // 10% above max
                ]}
        tickFormatter={(val) => val.toFixed(0) } // ⬅️ format decimals
        >
         <Label value="2025 Vote Share" position="insideBottom" offset={-5} />

        </XAxis>
        <YAxis
          type="number"
          dataKey="y"
          name="Predicted Vote Share"
          unit="%"
          domain={[
                    (dataMin) => dataMin * 0.9,   // 10% below min
                    (dataMax) => dataMax * 1.1,   // 10% above max
                ]}
        tickFormatter={(val) => val.toFixed(0) } // ⬅️ format decimals
        >
        <Label
            value="Predicted Vote Share"
            angle={-90}
            position="insideLeft"
            style={{ textAnchor: "middle" }}
        />
          </YAxis>   
           {/* ⬅️ Define the Z axis for point size */}
            <ZAxis
                type="number"
                dataKey="size"
                range={[30, 100]}   // min and max radius in pixels
                name="Change"
            />
        <Legend
            verticalAlign="bottom" 
            align="center"       
            wrapperStyle={{ paddingTop: 20  }} />

        {Object.keys(GROUP_COLOURS).map((group) => (
        <Scatter
            key={group}
            name={group}
            data={data.filter((d) => d.group === group)}
            fill={GROUP_COLOURS[group]}
            line={false}
            shape="circle"
            dataKey="x"   // ⬅️ Recharts handles y + size via YAxis + ZAxis
            onMouseEnter={(e) => setHovered(e)}   // capture hovered point
            onMouseLeave={() => setHovered(null)} // clear on exit
        />
        ))}
      </ScatterChart>
    </ResponsiveContainer>
          {/* ⬇️ Custom tooltip lives HERE, inside the wrapper <div> */}
      {hovered && (
        <div
          style={{
            position: "absolute",
            left: hovered.cx + 20, // offset from point
            top: hovered.cy,
            background: "white",
            padding: "8px",
            border: "1px solid #ccc",
            pointerEvents: "none", // don't block mouse
          }}
        >
          <strong>{hovered.payload.name}</strong> {hovered.payload.group}
          <div>2025 Vote Share: {hovered.payload.x.toFixed(1)}%</div>
          <div>Predicted: {hovered.payload.y.toFixed(1)}%</div>
          <div>Change: {hovered.payload.changelabel.toFixed(1)}%</div>
        </div>
      )}
    </div>
  );
}
